<script setup>
// §8.3 ActionLink — "Open timesheet →". A standalone navigational link.
// D6/§7: carried by position, weight and the arrow; underline on hover/focus
// ONLY. The arrow is part of the component so it is never dropped.
//
// `destructive` swaps the label to the same danger hue LButton's destructive
// variant uses (--status-rejected-text) — for a reject/remove/revoke action
// that reads as a link rather than a button.
defineProps({
  href: { type: String, default: null },
  arrow: { type: Boolean, default: true },
  destructive: { type: Boolean, default: false },
})
</script>

<template>
  <component :is="href ? 'a' : 'button'" :href="href" class="l-action-link" :class="{ destructive }" :type="href ? undefined : 'button'">
    <slot />
    <span v-if="arrow" aria-hidden="true" class="arrow">→</span>
  </component>
</template>

<style scoped>
.l-action-link {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-1);
  font-family: var(--font-ui);
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--interactive-text);
  background: none;
  border: 0;
  padding: 2px 0;
  min-height: var(--target-min);
  cursor: pointer;
  text-decoration: none;
}
.l-action-link:hover,
.l-action-link:focus-visible {
  text-decoration: underline;
  text-underline-offset: 2px;
}
.l-action-link.destructive {
  color: var(--status-rejected-text);
}
.arrow {
  transition: transform var(--t-fast) var(--ease);
}
.l-action-link:hover .arrow {
  transform: translateX(2px);
}
</style>
